<template><router-view /></template>
<style src="./assets/workspace.css"></style>
